module.exports = __webpack_public_path__ + "static/media/Gb1.1907926a.mp3";